exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remark[data-v-5d1fb1ab] {\n    width: 160px !important;\n}\n.unit[data-v-5d1fb1ab] {\n    width: 130px;\n}\n.width-auto[data-v-5d1fb1ab] {\n    width: auto;\n}\n@media screen and (max-width: 500px) {\n.width-auto[data-v-5d1fb1ab] {\n        width: 100%;\n}\n.width-auto + .width-auto[data-v-5d1fb1ab],\n    .width-auto[data-v-5d1fb1ab] {\n        margin-top: .5em;\n}\n}\n", ""]);

// exports
